export default {
  myAssetLibrary: '我的资产库',
  cancel: '取消',
  confirm: '确认',
  continue: '继续',
  filter: {
    search: '搜索',
    assetName: '资产名称',
    assetId: '资产ID',
    updateTime: '更新时间',
    createTime: '创建时间',
    format: '格式',
    type: '类型',
    image: '图片',
    video: '视频',
    audio: '音频',
    h5: 'h5',
    psd: 'psd',
    font: '字体',
    zip: '压缩包',
    dragonbone: '龙骨',
    seqframe: '序列帧',
    screenRecordFile: '录屏工程文件',
    proportion: '比例',
    direction: '方向',
    horizontal: '横',
    vertical: '竖',
    square: '方',
    duration: '时长',
    second: '秒',
    minute: '分',
    hour: '小时',
    codeRate: '码率',
    fileSize: '文件大小',
    size: '尺寸',
    date: '日期',
    width: '宽',
    high: '高',
    widthSize: '宽度',
    highSize: '高度',
    other: '其它',
    min: '最小',
    max: '最大',
    upload: '上传',
    share: '团队分享',
    synchronization: '系统同步',
    playturbo: 'Playturbo生成',
    source: '资产来源',
    today: '今天',
    week: '最近一周',
    searchSize: '大小',
    createdate: '创建日期',
    updatedate: '更新日期',
  },
}
